import { motion } from "framer-motion";

const videos = [
  { id: "JYnE1xk0UXM", title: "Getting Started with Clawbiz" },
  { id: "azpnJxRmE0o", title: "WhatsApp & Telegram Integration" },
  { id: "g7YpHmVN4U8", title: "Shell & File Automation" },
  { id: "N6Mip-0DdpU", title: "Multi-Channel Setup" },
  { id: "xvin5r0AOSM", title: "Model Routing & Config" },
  { id: "Kpt-MHDKT0M", title: "Browser & Web Skills" },
  { id: "RtMHxDnvJLQ", title: "Custom Skills & Workflows" },
  { id: "z1FgdEGW95E", title: "Migration & Rescue" },
];

export const VideosSection = () => {
  return (
    <section className="section-spacing relative overflow-hidden">
      <div className="section-container relative z-10">
        <motion.div
          className="text-center space-y-4 mb-12"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <h2 className="text-3xl md:text-5xl font-display font-medium leading-tight">
            See Clawbiz in <span className="text-gradient-coral">Action</span>
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Watch how it works across real setups, integrations, and workflows.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto">
          {videos.map((video, i) => (
            <motion.div
              key={video.id}
              className="glass-card rounded-2xl overflow-hidden group hover:bg-white/[0.04] transition-all duration-300"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: i * 0.05 }}
            >
              <div className="relative w-full" style={{ paddingBottom: "56.25%" }}>
                <iframe
                  className="absolute inset-0 w-full h-full"
                  src={`https://www.youtube.com/embed/${video.id}`}
                  title={video.title}
                  allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                  loading="lazy"
                />
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
